import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null, // 登录用户信息
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {}
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    /* 合并更新（登录后整对象 / 只改头像 都用它） */
    SET_USER_INFO(state, payload) {
      state.userInfo = { ...state.userInfo, ...payload }
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    },

    /* 退出专用 */
    CLEAR_USER_INFO(state) {
      state.userInfo = {}
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    setUser({ commit }, user) {
      commit('SET_USER', user)
    }, /* 仅更新头像 */
    setAvatar({ commit }, avatarUrl) {
      commit('SET_USER_INFO', { virtualAvatar: avatarUrl })
    },

    /* 整对象覆盖（登录成功调） */
    setUserInfo({ commit }, userObj) {
      commit('SET_USER_INFO', userObj)
    },

    /* 退出 */
    clearUserInfo({ commit }) {
      commit('CLEAR_USER_INFO')
    }
  },
  getters: {
    avatar: state => state.userInfo.virtualAvatar || '',
    // getUser(state) {
    //   return state.user
    // }
  },
  modules: {
  }
})
